import React from 'react';
import { useNavigate } from 'react-router-dom';
import './InsuranceSection.css';

const InsuranceSection = () => {
    const navigate = useNavigate();

    const handleViewPolicies = () => {
        navigate('/policy');
    };

    const insuranceStats = [
        { number: '₹50L+', label: 'Average Health Cover', icon: '🏥' },
        { number: '95%+', label: 'Claim Settlement Rate', icon: '✅' },
        { number: '₹299/mo', label: 'Starting Premium', icon: '💰' },
        { number: '20+', label: 'Top Insurers', icon: '🏆' }
    ];

    const benefits = [
        { text: 'Cashless Treatment at 5000+ Hospitals', icon: '🏥' },
        { text: 'Tax Benefits up to ₹1L under 80D', icon: '📊' },
        { text: 'Pre & Post Hospitalization Coverage', icon: '✅' },
        { text: 'Instant Policy Download', icon: '⚡' }
    ];

    return (
        <section className="insurance-section meddylist-insurance">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="insurance-content">
                            <div className="section-badge">
                                <span className="badge-icon">🏥</span>
                                <span className="badge-text">Health Insurance</span>
                            </div>
                            
                            <h2 className="section-title">
                                Secure Your Health & 
                                <span className="highlight"> Financial Future</span>
                            </h2>
                            
                            <p className="section-description">
                                Get comprehensive health insurance coverage starting from just ₹299/month. 
                                Protect yourself and your family with India's top health insurance providers.
                            </p>

                            <div className="benefits-list">
                                {benefits.map((benefit, index) => (
                                    <div key={index} className="benefit-item">
                                        <span className="benefit-icon">{benefit.icon}</span>
                                        <span className="benefit-text">{benefit.text}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="cta-section">
                                <button 
                                    className="btn btn-primary btn-lg me-3"
                                    onClick={handleViewPolicies}
                                >
                                    View Health Plans
                                </button>
                                <button 
                                    className="btn btn-outline-primary btn-lg"
                                    onClick={handleViewPolicies}
                                >
                                    Compare Plans
                                </button>
                            </div>

                            <div className="trust-indicators">
                                <span className="trust-text">Trusted by 500K+ families nationwide</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="stats-container">
                            <div className="stats-grid">
                                {insuranceStats.map((stat, index) => (
                                    <div key={index} className="stat-card">
                                        <div className="stat-icon">{stat.icon}</div>
                                        <div className="stat-number">{stat.number}</div>
                                        <div className="stat-label">{stat.label}</div>
                                    </div>
                                ))}
                            </div>
                            
                            <div className="insurance-hero-image">
                                <div className="featured-plans">
                                    <div className="plan-tag">
                                        <div className="plan-icon">🏥</div>
                                        <div className="plan-text">
                                            <div className="plan-title">Family Health Plan</div>
                                            <div className="plan-subtitle">Comprehensive Health Coverage</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InsuranceSection;
